import React, { useState } from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import FAQList from "@src/pages/sharedSections/FAQList";
import Modal from "@src/components/atoms/Modal";
import Button from "@src/components/atoms/Button";
import { Loader } from "@src/components/atoms";
import { useDCContext } from "@src/context/dcContext";
import { useOperatorContext } from "@src/context/operatorContext";
import { trackActionActivity } from "../../utils/userActivityTracker";

const InactiveOperatorModal = (props) => {
  const { onConfirmAction } = props;
  const { profile } = useOperatorContext();
  const dc = useDCContext();
  const { customer } = profile;
  const {
    getDynamicReplacement,
    existsDynamicReplacements,
    countSimilarDynamicReplacements,
  } = dc;
  const customerCode = customer.customerCode;
  const [activeFAQ, setActiveFAQ] = useState("");
  const dynamicContentLoaded = existsDynamicReplacements(
    "inactive_account_messages__default__title",
  );
  const hasCustomMessage = existsDynamicReplacements(
    `inactive_account_messages__${customerCode}__title`,
  );
  const faqDCKeys = [];
  const signolLogoSRC = getDynamicReplacement("logos__signol__blue");

  const defaultMessageTitle = getDynamicReplacement(
    "inactive_account_messages__default__title",
  );
  const defaultMessage = getDynamicReplacement(
    "inactive_account_messages__default__message",
  );
  const defaultMessageActionText = getDynamicReplacement(
    "inactive_account_messages__default__action_text",
  );

  const customMessageTitle = getDynamicReplacement(
    `inactive_account_messages__${customerCode}__title`,
    {},
    "",
  );
  const customMessagePrimary = getDynamicReplacement(
    `inactive_account_messages__${customerCode}__main_message`,
    {},
    "",
  );
  const customMessageSecondary = getDynamicReplacement(
    `inactive_account_messages__${customerCode}__secondary_message`,
    {},
    "",
  );
  const customMessageFAQTitle = getDynamicReplacement(
    `inactive_account_messages__${customerCode}__faq__title`,
    {},
    "",
  );
  const customMessageImgUrl = getDynamicReplacement(
    `inactive_account_messages__${customerCode}__img`,
    {},
    "",
    true,
  );
  const customMessageActionText = getDynamicReplacement(
    `inactive_account_messages__${customerCode}__action_text`,
    {},
    "",
  );

  const open = (faqId) => {
    trackActionActivity(`INACTIVE-ACCOUNT-FAQ-${faqId}`);
    if (activeFAQ === faqId) {
      setActiveFAQ("");
    } else {
      setActiveFAQ(faqId);
    }
  };

  const numberOfFaqs = countSimilarDynamicReplacements(
    `inactive_account_messages__${customerCode}__faq__q`,
  );
  for (let f = 0; f < numberOfFaqs; f++) {
    if (
      existsDynamicReplacements(
        `inactive_account_messages__${customerCode}__faq__q${f + 1}`,
      ) &&
      existsDynamicReplacements(
        `inactive_account_messages__${customerCode}__faq__a${f + 1}`,
      )
    ) {
      faqDCKeys.push(
        `inactive_account_messages__${customerCode}__faq__q${f + 1}`,
      );
    }
  }

  return (
    <div className="h-screen flex justify-center items-center dimmer">
      {!dynamicContentLoaded && <Loader size="2xl" />}
      {dynamicContentLoaded && (
        <Modal
          hideCloseButton={true}
          open={true}
          className={`${hasCustomMessage ? "max-w-4xl" : "max-w-xl"} w-10/12 md:w-2/3 rounded-xl shadow-xl`}
        >
          {!hasCustomMessage && (
            <div className="mx-auto px-8 py-4 text-center">
              <div className="text-2xl text-primary-500 font-bold my-3">
                {defaultMessageTitle}
              </div>
              <div className="p-6 text-sm">{defaultMessage}</div>
              <Button onClick={onConfirmAction}>
                {defaultMessageActionText}
              </Button>
            </div>
          )}
          {hasCustomMessage && (
            <div className="h-full flex">
              <div className="hidden lg:flex items-center relative overflow-hidden w-2/5">
                <img
                  className="relative z-10"
                  style={{ minWidth: "123%" }}
                  src={customMessageImgUrl}
                />
                <div
                  className="absolute dimmer"
                  style={{
                    height: "1276px",
                    width: "726px",
                    transform: "rotate(180deg)",
                    top: "-319px",
                    left: "-181px",
                  }}
                />
              </div>
              <div className="flex flex-col text-center text-gray-400 py-10 lg:w-3/5">
                <div className="w-full flex flex-col items-center lg:hidden mb-8 px-8">
                  <img className="w-44" src={signolLogoSRC} />
                </div>
                <h2 className="font-extrabold text-2xl m-0 text-primary mb-6 px-8">
                  {customMessageTitle}
                </h2>
                <div className="sm:px-24 mb-8">{customMessagePrimary}</div>
                {faqDCKeys.length > 0 && (
                  <div className="flex flex-col mb-8 lg:h-inactiveModalFAQs">
                    <h2 className="font-extrabold text-2xl m-0 text-primary mb-6">
                      {customMessageFAQTitle}
                    </h2>
                    <div className="overflow-auto px-8">
                      <FAQList
                        faqDCKeys={faqDCKeys}
                        eventName={customer.preferredEventName.toLowerCase()}
                        getDynamicContentFunc={getDynamicReplacement}
                        activeFAQ={activeFAQ}
                        openFAQFunc={open}
                      />
                    </div>
                  </div>
                )}
                <div className="px-8">{customMessageSecondary}</div>
                <Button onClick={onConfirmAction}>
                  {customMessageActionText}
                </Button>
              </div>
            </div>
          )}
        </Modal>
      )}
    </div>
  );
};

export const InactiveOperatorControls = {
  onConfirmAction: {
    propType: PropTypes.func.isRequired,
    description: "Confirm action handler function",
    disable: true,
  },
};

Modal.propTypes = AppUtils.getPropTypeFromControls(InactiveOperatorControls);

export default InactiveOperatorModal;
